"use client";

import { Suspense, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { installGlobalErrorHandlers, track } from "@/lib/analytics";

function PageViewTracker() {
  const pathname = usePathname();
  const search = useSearchParams();
  // Skip duplicate fires within the same tick (StrictMode double-effect).
  const lastRef = useRef<string | null>(null);

  useEffect(() => {
    const key = pathname + (search?.toString() ? `?${search.toString()}` : "");
    if (lastRef.current === key) return;
    lastRef.current = key;
    track("page_view", { path: pathname });
  }, [pathname, search]);

  return null;
}

/**
 * Mounts global error handlers + a page-view tracker. Page views are how we
 * get geo data on most users — without an event per navigation, users who
 * never click a tracked action stay invisible in the admin (location = "—").
 *
 * Renders nothing visible.
 */
export function AnalyticsProvider() {
  useEffect(() => {
    installGlobalErrorHandlers();
  }, []);
  return (
    <Suspense fallback={null}>
      <PageViewTracker />
    </Suspense>
  );
}
